:host {
  display: block;
  margin-left: 1em;
  position: relative;
}

button{
  padding:0;
  margin:0;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

dnn-collapsible{
  position: absolute;
  display: none;
  border: 1px solid lightgray;
  box-shadow: 2px 2px 4px -2px;
  background-color: white;
  z-index: 1;
}